import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { icons } from '../../../../../shared/icons';
import noImage from '../slike/noImage.png';
import saleImg from '../slike/sale.png';
import { formatPrice } from '../../../../../utils/FormatPrice';
import { useTranslation } from 'react-i18next';

const ProductSlider = ({ products, handleShopClick, handleOpenDetail }) => {
  const { t, i18n } = useTranslation();
  const settings = {
    dots: true,
    infinite: products.length > 5,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: products.length > 5,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: products.length > 4,
          arrows: products.length > 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: products.length > 3,
          arrows: products.length > 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: products.length > 2,
          arrows: products.length > 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: products.length > 1,
          arrows: products.length > 1,
        },
      },
    ],
  };

  return (
    <Slider {...settings} style={{ width: '85%' }}>
      {products.map((product, index) => (
        <div
          key={index}
          className="slider-items"
          onClick={(e) => handleOpenDetail(e, product)}
        >
          <div style={{ padding: '25px', position: 'relative' }}>
            {product.akcija && (
              <img
                src={saleImg}
                alt="Sale"
                style={{
                  position: 'absolute',
                  top: '0',
                  left: '0',
                  width: '50px',
                  height: '50px',
                }}
              />
            )}
            <img
              className="product-slider"
              src={product.slikaUrl || noImage}
              alt={product.naziv}
              style={{ width: '100%', borderRadius: '11px' }}
            />
          </div>
          <div className="shop-data">
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <h3 style={{ minHeight: '80px', margin: '3px' }}>
                {product.naziv}
              </h3>
              <h3
                style={{
                  minHeight: '80px',
                  margin: '3px',
                  textOverflow: 'ellipsis',
                  width: '170px',
                  whiteSpace: 'wrap',
                  overflow: 'hidden',
                }}
              >
                {t('partNumber')}: {product.partNumber}
              </h3>
              {product.rabat !== 0 && (
                <div>
                  <div style={{ display: 'flex', gap: '5px' }}>
                    <div
                      style={{
                        backgroundColor: '#e00',
                        borderRadius: '4px',
                        color: '#fff',
                        width: '40px',
                        height: '20px',
                        textAlign: 'center',
                      }}
                    >
                      {product.rabat}%
                    </div>{' '}
                    <div style={{ fontWeight: 'bold', color: '#e00' }}>
                      <span style={{ fontWeight: '100' }}>{t('saving')}:</span>{' '}
                      {formatPrice(product.usteda)}{' '}
                      <span style={{ fontSize: '15px' }}>EUR</span>
                    </div>
                  </div>
                  <div
                    style={{
                      color: '#a0a0a0',
                      textDecoration: 'line-through',
                    }}
                  >
                    {formatPrice(product.prodajnaCena)}{' '}
                    <span style={{ fontSize: '15px' }}>EUR</span>
                  </div>
                </div>
              )}
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <h3 style={{ margin: '3px' }}>
                  {formatPrice(product.fakturnaCena)}
                </h3>{' '}
                <span style={{ color: 'gray', fontWeight: '600' }}>EUR</span>
              </div>
            </div>
            <button
              className="shop-button"
              onClick={(e) => handleShopClick(e, product)}
            >
              {icons.SHOP_ICON}
            </button>
          </div>
        </div>
      ))}
    </Slider>
  );
};

const SampleNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: 'block' }}
      onClick={onClick}
    />
  );
};

const SamplePrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: 'block' }}
      onClick={onClick}
    />
  );
};

export default ProductSlider;
